import React from "react";
import "./OptionList.scss"
const OptionList = ({ header, subheader, icon, listColor }) => {
    return (
        <div className="OptionList">
            <div className={listColor === "purple" ? "OptionList-icon-purple" : listColor === "green" ? "OptionList-icon-green" : "OptionList-icon-blue"}>
                <img alt="" src={icon} />
            </div>
            <div className="OptionList-right">
                <div className="OptionList-right-header">
                    {header}
                </div>
                <div className="OptionList-right-subheader">
                    {subheader}
                </div>

            </div>
        </div>
    )
}
export default OptionList